function Users(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_798_268)">
        <path
          d="M7.21875 13.75C9.68677 13.75 11.6875 11.7493 11.6875 9.28125C11.6875 6.81323 9.68677 4.8125 7.21875 4.8125C4.75073 4.8125 2.75 6.81323 2.75 9.28125C2.75 11.7493 4.75073 13.75 7.21875 13.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.87915 17.1875C1.56587 16.1316 2.50543 15.264 3.61253 14.6634C4.71964 14.0628 5.95923 13.7482 7.21876 13.7482C8.47829 13.7482 9.71788 14.0628 10.825 14.6634C11.9321 15.264 12.8717 16.1316 13.5584 17.1875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7812 13.75C16.0407 13.7493 17.2804 14.0633 18.3876 14.6637C19.4948 15.264 20.4343 16.1316 21.1209 17.1875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1218 5.13047C13.7331 4.88666 14.3907 4.78088 15.0476 4.82068C15.7045 4.86048 16.3445 5.04489 16.9219 5.36072C17.4993 5.67656 17.9998 6.11602 18.3876 6.6477C18.7754 7.17939 19.0411 7.79018 19.1655 8.43643C19.2899 9.08268 19.27 9.74843 19.1073 10.3861C18.9446 11.0238 18.6431 11.6177 18.2242 12.1253C17.8054 12.6329 17.2796 13.0418 16.6844 13.3226C16.0892 13.6035 15.4394 13.7494 14.7812 13.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_798_268">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Users;
